import { TimerInfoState } from "../../../../../../../api/types";
import {
  PremiumPubTournamentTimerCircle,
  PremiumPubTournamentTimerWrapper,
} from "./style";

interface PremiumPubTournamentTimerProps {
  timer: TimerInfoState;
  radius: number;
  width?: number;
}

const PremiumPubTournamentTimer = ({
  timer,
  width,
  radius,
}: PremiumPubTournamentTimerProps) => {
  const circumference = 2 * Math.PI * radius;

  const formatTime = (value: string) => {
    if (value.includes("hour")) {
      if (+value.split("hour")[0] <= 24) {
        return value;
      }
      const day = (+value.split("hour")[0] / 24).toFixed();
      return `${day}day`;
    }
    return value;
  };

  return (
    <PremiumPubTournamentTimerWrapper width={width}>
      <PremiumPubTournamentTimerCircle
        progress={timer?.progress ? timer?.progress : 0}
        width={width}
      >
        <circle className="background" r={radius} cx={radius} cy={radius} />
        <circle
          className="progress"
          r={radius}
          cx={radius}
          cy={radius}
          stroke="url(#gradient)"
          strokeWidth="5"
          strokeDasharray={circumference}
          strokeDashoffset={
            timer.currentLevel.type === "READY"
              ? 0
              : (circumference * -timer.progress) / 100
          }
        />
        <defs>
          <radialGradient
            id="gradient"
            cx="95%"
            cy="50%"
            r="80%"
            fx="100%"
            fy="50%"
          >
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="49.5%" stopColor="#FF8787" />
            <stop offset="100%" stopColor="#FF0000" />
          </radialGradient>
        </defs>
      </PremiumPubTournamentTimerCircle>
      <div className="time">
        {formatTime(timer.remainingTimeInCurrentLevel)}
      </div>
    </PremiumPubTournamentTimerWrapper>
  );
};

export default PremiumPubTournamentTimer;
